function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import classnames from 'classnames';
import _ from 'lodash/fp';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import React, { useContext, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useBoolean, useMount, usePrevious, usePreviousDistinct, useUnmount } from 'react-use';
import { PulseLoader } from 'react-spinners';
import { MEMBERSHIP } from '../../constants/membership';
import { PRODUCT_TYPE, SMART_SELECTION_DELIVERY_METHOD } from '../../constants/product';
import useWorkerCallback from '../../hooks/useWorkerCallback';
import OrderWizard from '../../pages/billing/OrderWizard/OrderWizard';
import { clearSmartSelections, createJob, hideModal, quoteOrder, setMembershipPriceId, showModal, toggleRightMenuVisibility, updateJob } from '../../redux/actions';
import routes from '../../routes/constants';
import text from '../../text';
import { getNowDate } from '../../utilities/date';
import { isArrayEqual } from '../../utilities/lodash';
import { convertToGeoJson } from '../../utilities/map';
import { isRouteIncluded } from '../../utilities/routes';
import CollapseButton from '../button/CollapseButton';
import { PRODUCT_DATA } from '../mapView/constants';
import { convertGeometries } from '../mapView/drawingManager/utilities';
import ExpandableCheckoutBox from '../mapView/expandableCheckoutBox';
import { MapViewContext } from '../mapView/mapViewContext';
import ProductTooltip from '../mapView/productTooltip/ProductTooltip';
import { FORCE_JOB_UPDATE_MODAL } from '../modal/forceJobUpdateModal';
import { NO_DATA_MODAL } from '../modal/NoDataModal';
import { STATUS } from '../orderListing/consts';
import CartTable from './CartTable';
import CtaButton from './CtaButton';
import SmartSelectionsButton from './SmartSelectionsButton';
export var RIGHT_MENU_WIDTH_PX = 380; // KEEP THIS in coordination with $md-right-menu-width variable
var ROUTES_CART_BUTTON_OVERLAYED = [
    routes.fileManager.root,
    routes.view3D.root
];
var isCartButtonOverlayed = isRouteIncluded(ROUTES_CART_BUTTON_OVERLAYED);
var isRightMenuVisible = isRouteIncluded([
    routes.order.root,
    routes.order.job(),
    routes.view3D.project(),
    routes.fileManager.viewProject()
]);
var RightMenu = function() {
    var _state_job, _state_job1, _window;
    var isCartButtonOverlay = isCartButtonOverlayed(location.pathname);
    var dispatch = useDispatch();
    var history = useHistory();
    var jobId = useParams().jobId;
    var search = useLocation().search;
    var _useContext = useContext(MapViewContext), state = _useContext.state, actions = _useContext.actions;
    var _useBoolean = _sliced_to_array(useBoolean(false), 2), hasNoData = _useBoolean[0], setHasNoData = _useBoolean[1];
    var _useBoolean1 = _sliced_to_array(useBoolean(false), 2), hasAddressChanged = _useBoolean1[0], setAddressChanged = _useBoolean1[1];
    var _useSelector = useSelector(function(reduxState) {
        return {
            mapState: reduxState.mapReducer,
            layout: reduxState.layout,
            currentUser: reduxState.profileReducer.userProfile,
            job: reduxState.jobsReducer.job,
            undefinedAddress: reduxState.jobsReducer.undefinedAddress
        };
    }), mapState = _useSelector.mapState, layout = _useSelector.layout, undefinedAddress = _useSelector.undefinedAddress;
    var isReadOnly = !!state.job && ((_state_job = state.job) === null || _state_job === void 0 ? void 0 : _state_job.status) !== STATUS.DRAFT || ((_state_job1 = state.job) === null || _state_job1 === void 0 ? void 0 : _state_job1.status) === STATUS.DEMO;
    var previousSelections = usePrevious(state.selections);
    var previousCoverage = usePrevious(state.coverage);
    var previousDistinctAddress = usePreviousDistinct(state.address);
    var previousDistinctJobId = usePreviousDistinct(jobId);
    // Note: Can't use hasAddressChanged state coz it's only reset to false when hasNoData is true as well
    var _useBoolean2 = _sliced_to_array(useBoolean(false), 2), isOrderAddressChanged = _useBoolean2[0], setIsOrderAddressChanged = _useBoolean2[1];
    useMount(function() {
        return dispatch(setMembershipPriceId(MEMBERSHIP.NO_MEMBERSHIP));
    });
    useEffect(function() {
        if (jobId && previousDistinctJobId && jobId !== previousDistinctJobId) {
            actions.setHasLoadedJob(false);
        }
    }, [
        window.location.href
    ]);
    useEffect(function() {
        if (jobId && previousDistinctJobId) {
            // actions.setActiveSelectionId(null);
            actions.setGeometries({});
            actions.setGeometriesToLoad({});
        }
    }, [
        jobId,
        previousDistinctJobId
    ]);
    useUnmount(function() {
        dispatch(clearSmartSelections());
    });
    // useEffect(() => {
    //   if (state.hasLoadedJob && state.isMapVisible && state.map) {
    //     // Handle when map zoom is too small e.g. selections are far apart
    //     // Focus on latest added selection
    //     if (state.map?.zoom < PREFERRED_MAP_ZOOM && !isEmpty(state.selections)) {
    //       const latestSelection = orderBy(
    //         state.selections,
    //         ['created_at'],
    //         ['desc']
    //       )[0];
    //       state.map?.fitBounds(
    //         getRegionBounds(latestSelection.region),
    //         MAP_BOUNDS_PADDING
    //       );
    //     }
    //   }
    // }, [state.hasLoadedJob, state.isMapVisible]);
    var onHideNoData = function() {
        setHasNoData(false);
        dispatch(hideModal(NO_DATA_MODAL));
    };
    useEffect(function() {
        _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(state.address && !isEqual(previousDistinctAddress, state.address))) return [
                            3,
                            2
                        ];
                        setAddressChanged(true);
                        setIsOrderAddressChanged(true);
                        if (!(hasAddressChanged && state.job)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            dispatch(updateJob({
                                address: state.address,
                                jobId: state.job.id,
                                updatedAt: getNowDate()
                            }))
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        state.address
    ]);
    useEffect(function() {
        if (hasAddressChanged && hasNoData) {
            dispatch(showModal(NO_DATA_MODAL, {
                onHide: onHideNoData
            }));
        }
        if (hasNoData) {
            setHasNoData(false);
            setAddressChanged(false);
        }
    }, [
        hasAddressChanged,
        hasNoData
    ]);
    var quoteSelections = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(selections, property, targetProjectId) {
            var job_id, createdJob, job, request, propertyData, data;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        job_id = jobId;
                        createdJob = false;
                        if (!!jobId) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            onSaveJob(false, targetProjectId)
                        ];
                    case 1:
                        job = _state.sent();
                        job_id = job === null || job === void 0 ? void 0 : job.id;
                        createdJob = job === null || job === void 0 ? void 0 : job.createdJob;
                        _state.label = 2;
                    case 2:
                        request = {
                            selections: selections.map(function(selection) {
                                return {
                                    id: selection.id,
                                    region: convertToGeoJson([
                                        selection
                                    ]).features[0].geometry,
                                    product_id: selection.product_id,
                                    created_at: selection.created_at,
                                    ui_state: {
                                        type: selection.region.type,
                                        name: selection.name,
                                        line_path: selection.region.type === 'Polyline' ? selection.region.include.map(function(points) {
                                            return [
                                                points[1],
                                                points[0]
                                            ];
                                        }) : []
                                    },
                                    parent_selection_id: selection.parent_selection_id || ''
                                };
                            })
                        };
                        propertyData = !isEmpty(selections) ? property : undefined;
                        return [
                            4,
                            dispatch(quoteOrder(job_id, request, true, propertyData))
                        ];
                    case 3:
                        data = _state.sent();
                        if (createdJob && job_id) {
                            actions.setHasLoadedJob(false);
                            history.replace({
                                pathname: routes.order.job(job_id),
                                search: location.search
                            });
                        }
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function quoteSelections(selections, property, targetProjectId) {
            return _ref.apply(this, arguments);
        };
    }();
    var searchParams = useMemo(function() {
        return new URLSearchParams(search);
    }, [
        search
    ]);
    /**
   * Quote selections when they change.
   */ useEffect(function() {
        if (isReadOnly || !state.isMapVisible || !state.selections || isArrayEqual(state.selections, previousSelections, [
            'focused'
        ])) {
            return;
        }
        quoteSelections(state.selections, mapState.boundaries, searchParams.get('projectId') || null);
    }, [
        state.selections
    ]);
    /**
   * Update region of active selection when region selection changes.
   */ useEffect(function() {
        if (!state.selections || !state.coverage || !state.debouncedRegionSelection || !state.coverageInRegionSelection || !state.activeSelection) {
            return;
        }
        var region = Object.values(convertGeometries(state.debouncedRegionSelection, false))[0].region;
        if (!region) {
            console.warn('No region selection found');
            return null;
        }
        // const layers = _.find(
        //   ['category_name', state.activeSelection.category_name],
        //   state.coverageInRegionSelection
        // )?.layers;
        var newActiveSelection = _.flow(_.set('region', region))(_.find([
            'id',
            state.activeSelection.id
        ], state.selections));
        actions.setSelections(_.map(function(selection) {
            if (selection.id !== state.activeSelection.id) {
                return selection;
            }
            return newActiveSelection;
        })(state.selections));
        actions.setActiveSelectionId(newActiveSelection.id);
    }, [
        state.coverageInRegionSelection
    ]);
    /**
   * Set `productAvailability` whenever the region selection changes.
   * A product is available iff there are 1 or more layers in the current region selection OR
   * there are 1 or more layers in the default region.
   */ useEffect(function() {
        var mapped = _.map(function(productType) {
            var __find;
            if (!_.isEmpty(state.debouncedRegionSelection)) {
                var __find1;
                var regionSelectionLayers = (__find1 = _.find([
                    'category_name',
                    productType
                ], state.coverageInRegionSelection)) === null || __find1 === void 0 ? void 0 : __find1.layers;
                var available = regionSelectionLayers && _.size(regionSelectionLayers) > 0 || false;
                return [
                    productType,
                    available
                ];
            }
            var defaultRegionLayers = (__find = _.find([
                'category_name',
                productType
            ], state.coverageInDefaultRegion)) === null || __find === void 0 ? void 0 : __find.layers;
            var available1 = defaultRegionLayers && _.size(defaultRegionLayers) > 0 || false;
            return [
                productType,
                available1
            ];
        }, PRODUCT_DATA.result);
        var availability = _.fromPairs(mapped);
        actions.setProductAvailability(availability);
    }, [
        state.debouncedRegionSelection,
        state.coverageInRegionSelection,
        state.defaultRegion,
        state.coverageInDefaultRegion
    ]);
    var getSelectionProductAvailabilityWorker = useMemo(function() {
        return new Worker(new URL('../../workers/getSelectionProductAvailability.worker.js', import.meta.url));
    }, []);
    var setSelectionProductAvailability = useWorkerCallback(getSelectionProductAvailabilityWorker, function(data) {
        actions.setSelectionProductAvailability(data);
    });
    useEffect(function() {
        var _window;
        if (!((_window = window) === null || _window === void 0 ? void 0 : _window.Worker)) {
            return;
        }
        if (!state.selections || !state.coverage || isArrayEqual(state.selections, previousSelections, [
            'focused',
            'visible'
        ]) && isArrayEqual(state.coverage, previousCoverage)) {
            return;
        }
        setSelectionProductAvailability({
            coverage: state.coverage,
            selections: state.selections
        });
    }, [
        (_window = window) === null || _window === void 0 ? void 0 : _window.Worker,
        state.selections,
        state.coverage
    ]);
    var onSaveJob = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var force, targetProjectId, _state_job, data, jobExists, job;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        force = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false, targetProjectId = _arguments.length > 1 ? _arguments[1] : void 0;
                        data = {
                            address: _object_spread({}, state.address),
                            message: state.requestMessage,
                            projectName: state.project.name,
                            lot_area_state: {
                                visibility: false,
                                hidden: true
                            }
                        };
                        jobExists = !!((_state_job = state.job) === null || _state_job === void 0 ? void 0 : _state_job.id);
                        return [
                            4,
                            dispatch(jobExists ? updateJob(_object_spread_props(_object_spread({}, data), {
                                jobId: state.job.id,
                                updatedAt: state.job.updated_at,
                                force: force,
                                onConflict: onShowForceSave
                            })) : createJob(_object_spread_props(_object_spread({}, data, targetProjectId ? {
                                mergeProjectId: targetProjectId
                            } : {}), {
                                lot_area_state: {
                                    visibility: !undefinedAddress,
                                    hidden: undefinedAddress
                                }
                            })))
                        ];
                    case 1:
                        job = _state.sent();
                        return [
                            2,
                            _object_spread_props(_object_spread({}, job), {
                                createdJob: !jobExists
                            })
                        ];
                }
            });
        });
        return function onSaveJob() {
            return _ref.apply(this, arguments);
        };
    }();
    var onForceSaveAndExit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var job;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSaveJob(true)
                        ];
                    case 1:
                        job = _state.sent();
                        if (job) {
                            history.replace(routes.order.job(job.id));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onForceSaveAndExit() {
            return _ref.apply(this, arguments);
        };
    }();
    var onShowForceSave = function() {
        dispatch(showModal(FORCE_JOB_UPDATE_MODAL, {
            onSubmit: onForceSaveAndExit
        }));
    };
    useEffect(function() {
        if (!isEmpty(state.job) && state.hasShadowOverlay) {
            actions.setHasShadowOverlay(false);
        }
    }, [
        state.job
    ]);
    var shouldShowBuyNowButton = state.showAutomatic && !state.isCartEmpty && !isReadOnly;
    var shouldShowScanCaptureButton = state.showManual && !state.isCartEmpty && !isReadOnly;
    var noPresentAddOn = state.showBimAddOnButton && state.show2DFeaturePlanButton;
    var isAddOnButtonShowable = (state.showBimAddOnButton || state.show2DFeaturePlanButton) && !state.isCartEmpty && !isReadOnly;
    var shouldShowAddOnButtonSectionName = noPresentAddOn && isAddOnButtonShowable || shouldShowBuyNowButton;
    var isLoadingSmartSelections = mapState.isLoadingSmartSelections && mapState.loadingRhsButtonIds.length === 0;
    var isStillQuotingOrCheckingSmartSelections = state.isCartEmpty && (isLoadingSmartSelections || state.isStillQuoting);
    // show Search text loader whenever address is changed
    var isAddressSameWithPrevious = useMemo(function() {
        return state.address && isEqual(previousDistinctAddress, state.address);
    }, [
        previousDistinctAddress,
        state.address
    ]);
    var isFetchingNewAddressData = (!jobId || !isAddressSameWithPrevious) && previousDistinctAddress && isOrderAddressChanged;
    // reset isOrderAddressChanged to false when true and done quoting
    // this is to ensure that thinking animation (Cart loader) only shows when address is changed for the order
    useEffect(function() {
        if (!state.isStillQuoting) {
            setIsOrderAddressChanged(false);
        }
    }, [
        setIsOrderAddressChanged,
        state.isStillQuoting
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('RightMenuV2 overflow-hidden', {
            show: layout.rightMenu.isVisible,
            'd-none': !isRightMenuVisible(location.pathname)
        })
    }, isFetchingNewAddressData ? /*#__PURE__*/ React.createElement("div", {
        className: "loader-container"
    }, /*#__PURE__*/ React.createElement(PulseLoader, {
        color: "#31a283"
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(OrderWizard, {
        isOnlyBreadcrumbs: true,
        defaultStep: 0,
        isVisible: !state.isCartEmpty
    }), !isCartButtonOverlay || layout.rightMenu.isVisible ? /*#__PURE__*/ React.createElement(CollapseButton, {
        id: "rightMenuCollapseButton",
        openDirection: "left",
        isOpen: layout.rightMenu.isVisible,
        closeText: text('order'),
        tooltipProps: {
            text: text(layout.rightMenu.isVisible ? 'collapsePanel' : 'expandPanel'),
            placement: 'left'
        },
        onClick: function() {
            actions.setShowProductModal(false);
            dispatch(toggleRightMenuVisibility(!layout.rightMenu.isVisible));
        }
    }) : null, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-column flex-fill overflow-hidden"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "scrollbar-inner flex-fill overflow-auto"
    }, /*#__PURE__*/ React.createElement(CartTable, {
        isReadOnly: isReadOnly
    }), /*#__PURE__*/ React.createElement("div", {
        className: "position-relative"
    }, shouldShowBuyNowButton ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("hr", null), /*#__PURE__*/ React.createElement("h6", {
        className: "mt-2 text-uppercase"
    }, text('buyNow'))) : null, !undefinedAddress && /*#__PURE__*/ React.createElement(SmartSelectionsButton, {
        deliveryType: "automatic",
        show: state.showAutomatic || false,
        isReadOnly: isReadOnly,
        buttonId: SMART_SELECTION_DELIVERY_METHOD.AUTOMATIC
    }), shouldShowScanCaptureButton ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("hr", null), /*#__PURE__*/ React.createElement("h6", {
        className: "mt-2 text-uppercase"
    }, text('getQuote'))) : null, !undefinedAddress && /*#__PURE__*/ React.createElement(SmartSelectionsButton, {
        deliveryType: "manual",
        show: state.showManual || false,
        isReadOnly: isReadOnly,
        buttonId: SMART_SELECTION_DELIVERY_METHOD.MANUAL
    }), shouldShowAddOnButtonSectionName ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("hr", null), /*#__PURE__*/ React.createElement("h6", {
        className: "mt-2"
    }, text('addOns'))) : null, !isReadOnly && /*#__PURE__*/ React.createElement(CtaButton, {
        className: classnames({
            'mt-0': !shouldShowAddOnButtonSectionName
        }),
        show: state.showBimAddOnButton,
        header: text('getQuoteBim'),
        description: text('getQuoteBimDetails'),
        handleClick: function() {
            actions.createAddOnSelection(null, {}, true, {
                target: [
                    PRODUCT_TYPE.BIM_EXTERIOR,
                    PRODUCT_TYPE.BIM_INTERIOR
                ]
            });
        },
        tooltip: /*#__PURE__*/ React.createElement(ProductTooltip, {
            productType: PRODUCT_TYPE.BIM_EXTERIOR,
            placement: "top",
            title: text('getQuoteBim'),
            description: text('BIMTooltip')
        })
    }), !isReadOnly && /*#__PURE__*/ React.createElement(CtaButton, {
        className: classnames({
            'mt-0': !shouldShowAddOnButtonSectionName
        }),
        show: state.show2DFeaturePlanButton,
        header: text('getQuote2dFeaturePlan'),
        description: text('getQuote2dFeaturePlanDetails'),
        handleClick: function() {
            actions.createAddOnSelection(null, {}, true, {
                target: [
                    PRODUCT_TYPE.TWOD_PLAN_EXTERIOR,
                    PRODUCT_TYPE.TWOD_PLAN_INTERIOR
                ]
            });
        },
        tooltip: /*#__PURE__*/ React.createElement(ProductTooltip, {
            productType: PRODUCT_TYPE.TWOD_PLAN_EXTERIOR,
            placement: "top",
            title: text('featurePlans2D'),
            description: text('FeaturePlanToolTip')
        })
    })), isStillQuotingOrCheckingSmartSelections ? /*#__PURE__*/ React.createElement("div", {
        className: "loader-container has-backdrop"
    }, /*#__PURE__*/ React.createElement(PulseLoader, {
        color: "#31a283"
    })) : null), !state.isCartEmpty && /*#__PURE__*/ React.createElement(ExpandableCheckoutBox, {
        isReadOnly: isReadOnly
    }))));
};
export default RightMenu;
